var _path, _path2, _path3, _path4, _path5, _path6, _path7;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMobileHeaderLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.55066 9.08301H0L2.53481 11.098H6.89054L7.55066 9.08301Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.4652 14.3945L7.30573 14.8973L7.4652 14.3945Z",
    fill: "#3DF0F6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4494 9.08301L17.1076 11.098H21.4652L24 9.08301H16.4494Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5344 12.3447L18.0072 13.857L19.8578 12.3447H17.5344Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.44922 12.3447L5.97638 13.857L4.12579 12.3447H6.44922Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5612 24L11.9995 0L4.43951 24L7.32294 21.8549L11.9995 6.48967L16.5982 21.7967L19.5612 24Z",
    fill: "#DA291C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7644 16.2913L12.0393 15.6973L11.2383 16.334L10.1999 19.7448L12.0393 18.3781L13.7991 19.6866L12.7644 16.2913Z",
    fill: "#DA291C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileHeaderLogo);
export default __webpack_public_path__ + "static/media/mobile-header-logo.16008587.svg";
export { ForwardRef as ReactComponent };